import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import "./Video.css";

const Video = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  const [videoError, setVideoError] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    loadLanguageFile("Video", "video/video_body_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Video || { Main: {} };

  const handleVideoError = () => {
    console.error("影片載入失敗，請稍後再試。");
    setVideoError(true);
  };

  const handleLoadedData = () => {
    setVideoLoaded(true);
  };

  const videoUrl = LANGUAGE.Main.Content5;

  return (
    <div
      className="container-fluid py-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{
        visibility: 'visible',
        animationDelay: '0.1s',
        animationName: 'fadeInUp',
      }}
    >
      <div className="container py-5">
        <div
          className="section-title text-center position-relative pb-3 mb-5 mx-auto"
          style={{ maxWidth: '700px' }}
        >
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content2}</h5>
          <h1 className="mb-4">{LANGUAGE.Main.Content1}</h1>
          <p className="lead text-muted">{LANGUAGE.Main.Content3}</p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="video-wrapper text-center">
              {videoError ? (
                <div className="alert alert-danger">
                   {LANGUAGE.Main.Content4}
                </div>
              ) : videoUrl ? (
                <video
                  key={videoUrl}
                  autoPlay
                  muted
                  playsInline
                  controls
                  className="w-100 rounded shadow-lg"
                  style={{ maxHeight: "600px" }}
                  onError={handleVideoError}
                  onLoadedData={handleLoadedData}
                  preload="metadata"
                >
                  <source src={videoUrl} type="video/mp4" />
                  <p>{LANGUAGE.Main.Content4}</p>
                </video>
              ) : (
                <div className="text-muted">{LANGUAGE.Main.Content6}</div>
              )}

              {!videoLoaded && !videoError && videoUrl && (
                <div className="text-center text-secondary mt-3">
                  <small>{LANGUAGE.Main.Content7}</small>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
